import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import Education from '../pages/event/education';
import EducationCreate from '../pages/event/education/create';
import EducationRead from '../pages/event/education/read';
import EducationEdit from '../pages/event/education/edit';
import EducationRegister from '../pages/event/education/register';
import Briefing from '../pages/event/briefing';
import BriefingCreate from '../pages/event/briefing/create';
import BriefingRead from '../pages/event/briefing/read';
import BriefingEdit from '../pages/event/briefing/edit';
import BriefingRegister from '../pages/event/briefing/register';

const EventRouter: FC = () => {
  return (
    <Switch>
      <Route path='/event/education' exact component={Education} />
      <Route path='/event/education/create' exact component={EducationCreate} />
      <Route path='/event/education/:eventNo' exact component={EducationRead} />
      <Route path='/event/education/:eventNo/edit' exact component={EducationEdit} />
      <Route path='/event/education/:eventNo/register' exact component={EducationRegister} />
      <Route path='/event/briefing' exact component={Briefing} />
      <Route path='/event/briefing/create' exact component={BriefingCreate} />
      <Route path='/event/briefing/:eventNo' exact component={BriefingRead} />
      <Route path='/event/briefing/:eventNo/edit' exact component={BriefingEdit} />
      <Route path='/event/briefing/:eventNo/register' exact component={BriefingRegister} />
    </Switch>
  )
}

export default EventRouter;
